export default {
  modalTitle: 'Redimensionar componente',
  widthLabel: 'Ancho',
  widthPlaceholder: 'Por defecto',
  heightLabel: 'Alto',
  heightPlaceholder: 'Por defecto',
  widthSize: {
    SMALL: '2 Columnas',
    MID: '3 Columnas',
    LARGE: '4 Columnas',
    COL5: '5 Columnas',
    XLARGE: '6 Columnas',
    COL7: '7 Columnas',
    COL8: '8 Columnas',
    COL9: '9 Columnas',
    COL10: '10 Columnas',
    COL11: '11 Columnas',
    COL12: '12 Columnas',
  },
  heightSize: {
    SMALL: 'Pequeño',
    MID: 'Mediano',
    LARGE: 'Grande',
    XLARGE: 'Extra Grande',
  },
};
